Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) return ''; // prevent crash if no placeholder

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return value;
};

// wishlist get lists? check wishlist

function initSwymWishlistLogic() {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadLists);

  function onSwymLoadLists(swat) {
    // Define success callback
    let onSuccess = function (lists) {
      document.dispatchEvent(new CustomEvent("body"));
      // Successfully fetched all lists
      if (lists.length != 0) {
        if (lists[0].cnt > 0) {
          document.querySelector('.wishlist-not-empty').classList.remove('d-none');
        }
      }
    }

    // Define error callback
    let onError = function (error) {
      // Error is an xhrObject
      console.log("Error while fetching all Lists", error);
    }

    // Call `fetchLists` function
    swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError
    });
  }

  if (document.querySelector('.swym-button') != null) {
    document.querySelectorAll('.swym-button').forEach(function (item) {
      item.addEventListener('click', function (e) {
        setTimeout(function () {
          window.SwymCallbacks.push(onSwymLoadLists);

          function onSwymLoadLists(swat) {
            // Define success callback
            document.dispatchEvent(new CustomEvent("body"));
            let onSuccess = function (lists) {
              // Successfully fetched all lists
              if (lists.length != 0) {
                if (lists[0].cnt > 0) {
                  document.querySelector('.wishlist-not-empty').classList.remove('d-none');
                } else {
                  document.querySelector('.wishlist-not-empty').classList.add('d-none');
                }
                lists[0].listcontents.forEach(function (prod) {
                  if (prod.epi == item.dataset.variantId && item.dataset.coll) {
                    // Define the list id of the list to be updated
                    let lid = prod.lid;
                    // Define the product object
                    let product = {
                      epi: item.dataset.variantId,  // variant id of the product to be updated
                      empi: item.dataset.productId, // product id of the product to be updated
                      du: item.dataset.productUrl, // canonical uri of the product to be updated
                      note: item.dataset._2ndImg, //optional note
                      cprops: {
                        metaColl: item.dataset.coll
                      } //optional note
                    };
                    // Define success callback
                    let onSuccess = function (updatedListItem) {
                      // executed when successfully updated a list item
                      console.log("Successfully updated the List Item", updatedListItem);
                    }
                    // Define error callback
                    let onError = function (error) {
                      // Error is an xhrObject
                      console.log("Error while updating the List Item", error);
                    }
                    // Update a list with the above callbacks, lid and product map
                    swat.updateListItem(lid, product, onSuccess, onError);
                  }
                })
              }

            }


            // Define error callback
            let onError = function (error) {
              // Error is an xhrObject
              console.log("Error while fetching all Lists", error);
            }

            // Call `fetchLists` function
            swat.fetchLists({
              callbackFn: onSuccess,
              errorFn: onError
            });
          }
        }, 700)
      })
    })
  }
}

function initGiftCardLogic() {
    var textarea = document.getElementById('gift_card_message');
    if(textarea != null){
        textarea.addEventListener('input', function() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        });
    }
}

function updateRecipientMessageCounter(message) {
  const counter = message
    .closest('recipient-form')
    ?.querySelector('[data-recipient-message-counter]');

  if (!counter) return;

  counter.textContent = `${message.value.length} / ${message.maxLength}`;
}

function initRecipientMessageCounters(root = document) {
  root.querySelectorAll('[data-recipient-message]').forEach(updateRecipientMessageCounter);
}

document.addEventListener('input', (event) => {
  if (event.target.matches('[data-recipient-message]')) {
    updateRecipientMessageCounter(event.target);
  }
});

class PrintedGiftForm extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-printed-gift-toggle]');
    this.fields = this.querySelector('[data-printed-gift-fields]');
    this.message = this.querySelector('[data-printed-gift-message]');
    this.counter = this.querySelector('[data-printed-gift-counter]');

    if (!this.toggle || !this.fields || !this.message) return;

    this.handleToggle = this.handleToggle.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
    this.toggle.addEventListener('change', this.handleToggle);
    this.message.addEventListener('input', this.updateCounter);
    this.handleToggle();
    this.updateCounter();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.handleToggle);
    this.message?.removeEventListener('input', this.updateCounter);
  }

  handleToggle() {
    const isEnabled = this.toggle.checked;

    this.fields.hidden = !isEnabled;
    this.message.disabled = !isEnabled;
    this.toggle.setAttribute('aria-expanded', String(isEnabled));
  }

  updateCounter() {
    if (!this.counter) return;

    this.counter.textContent = `${this.message.value.length} / ${this.message.maxLength}`;
  }
}

if (!customElements.get('printed-gift-form')) {
  customElements.define('printed-gift-form', PrintedGiftForm);
}

class ProductOrderNote extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-product-order-note-toggle]');
    this.fields = this.querySelector('[data-product-order-note-fields]');
    this.message = this.querySelector('[data-product-order-note-message]');
    this.counter = this.querySelector('[data-product-order-note-counter]');
    this.variantAvailable = this.dataset.variantAvailable === 'true';

    if (!this.toggle || !this.fields || !this.message) return;

    this.handleToggle = this.handleToggle.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.toggle.addEventListener('change', this.handleToggle);
    this.message.addEventListener('input', this.handleInput);
    this.syncState();
    this.handleInput();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.handleToggle);
    this.message?.removeEventListener('input', this.handleInput);
  }

  handleToggle() {
    this.syncState();
  }

  setVariantAvailability(isAvailable) {
    this.variantAvailable = Boolean(isAvailable);
    this.dataset.variantAvailable = String(this.variantAvailable);
    this.syncState();
  }

  syncState() {
    const isExpanded = this.variantAvailable && this.toggle.checked;

    this.hidden = !this.variantAvailable;
    this.fields.hidden = !isExpanded;
    this.message.disabled = !isExpanded;
    this.toggle.setAttribute('aria-expanded', String(isExpanded));
    this.updatePropertyName();
  }

  handleInput() {
    if (this.counter) {
      this.counter.textContent = `${this.message.value.length} / ${this.message.maxLength}`;
    }

    this.updatePropertyName();
  }

  updatePropertyName() {
    const shouldSubmit =
      this.variantAvailable &&
      this.toggle.checked &&
      this.message.value.trim() !== '';

    if (shouldSubmit) {
      this.message.name = this.message.dataset.propertyName;
    } else {
      this.message.removeAttribute('name');
    }
  }
}

if (!customElements.get('product-order-note')) {
  customElements.define('product-order-note', ProductOrderNote);
}

document.addEventListener("DOMContentLoaded", function () {
  initSwymWishlistLogic();
  initGiftCardLogic();
  initRecipientMessageCounters();
});

// wishlist get lists END

let subscribers = {}
const PUB_SUB_EVENTS = {
    variantChange: 'variant-change'
};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = []
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback
        });
    }
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data)
        })
    }
}

class Variants extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateURL();
        this.renderProductInfo();
        this.updateProductPrice()

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
        } else {
            this.updateURL();
        }
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

  updateDiscountBadge() {
    const badge = document.querySelector('.sale-badge');
    const badgeContent = document.querySelector('.sale-badge span');

    if (!badge || !this.currentVariant) return;

    const price = this.currentVariant.price;
    const compare = this.currentVariant.compare_at_price;

    if (compare && compare > price) {
      const discount = Math.round(((compare - price) / compare) * 100);
      badgeContent.textContent = `-${discount}%`;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }


    async updateProductPrice() {
        const DEBUG = false;
        const log = (...a) => DEBUG && console.log('[Price]', ...a);
        const warn = (...a) => DEBUG && console.warn('[Price]', ...a);

        // Дочекаємось кадру, щоб чужі скрипти завершили свій рендер — ми будемо останні
        const nextFrame = () => new Promise(r => requestAnimationFrame(() => r()));
        await nextFrame();

        const productPrice = document.querySelector('.product-price.js-product-price');
        const productCompareAtPrice = document.querySelector('.product-price-compare');
        function getCurrencyFromSelector() {
          const selectedEl = document.querySelector('.header-currency-selected span');
          if (!selectedEl) return 'UAH';
          const text = selectedEl.textContent.trim();
          if (text == "ENG") return 'USD';
          if (text == "UKR") return 'UAH';
        }
        // const selectedCurrency = document.cookie.match(/(?:^|; )currency=([^;]*)/)?.[1] || 'UAH';
        const selectedCurrency = getCurrencyFromSelector();
        const useConversion = selectedCurrency !== 'UAH';

        let rates;
        try {
            const rawRates = await fetchExchangeRatesOnce();
            rates = rawRates ? parseRates(rawRates) : { 'USD_UAH': 43.18, 'UAH_USD': 1/43.18 };
        } catch (e) {
            warn('rates fallback:', e);
            rates = { 'USD_UAH': 43.18, 'UAH_USD': 1/43.18 };
        }

        if (!this.currentVariant) { warn('!currentVariant'); return; }
        const v = this.currentVariant;

        // 48 USD
        const formatCodeAfter = (amount, currency) => {
            const nf = new Intl.NumberFormat('en-US', {
                style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0, currencyDisplay: 'code'
            });
            const parts = nf.formatToParts(amount);
            const numberStr = parts.filter(p => p.type !== 'currency' && p.type !== 'literal').map(p => p.value).join('');
            return `${numberStr} ${currency}`;
        };

        // захист від “перегони озброєнь”
        this._priceGuard ??= { applying: false };
        const guard = this._priceGuard;

        const setText = (el, text) => {
            guard.applying = true;
            el.textContent = text;
            el.dataset.lastWriter = 'updateProductPrice';
            queueMicrotask(() => { guard.applying = false; });
        };

        const attachObserver = (el) => {
            if (!el || el.__priceObserver) return;
            const obs = new MutationObserver(() => {
                if (guard.applying) return; // ігноруємо власні зміни

                // якщо хтось змінив ціну, а варіант/валюта ті самі — реаплаїмо наше значення
                if (guard.variantId && guard.currency && el.textContent !== guard.mainText) {
                    warn('Зовнішня зміна productPrice:', { text: el.textContent });
                    setText(el, guard.mainText);
                }
            });
            obs.observe(el, { childList: true, characterData: true, subtree: true });
            el.__priceObserver = obs;
            log('Observer attached → productPrice');
        };

        // ----------- основна ціна
        if (productPrice) {
            const base = v.price / 100;
            const amount = useConversion ? convert(base, 'UAH', selectedCurrency, rates) : base;
            const text = useConversion
                ? formatCodeAfter(amount, selectedCurrency)
                : (window.Shopify.formatMoney(v.price).replace('.00', '').replace(/,/g, '') + ' UAH');

            // запам’ятаємо “правильну” ціну для реаплаю
            guard.variantId = v.id;
            guard.currency  = selectedCurrency;
            guard.mainText  = text;

            setText(productPrice, text);
            attachObserver(productPrice);

            // короткий пост-чек (для логів)
            setTimeout(() => log('Post-check DOM:', { price: productPrice.textContent, compare: productCompareAtPrice?.textContent }), 40);
        }

        // ----------- порівняльна ціна
        if (productCompareAtPrice) {
            const c = v.compare_at_price;
            if (c != null && c !== 0) {
                const base = c / 100;
                const amount = useConversion ? convert(base, 'UAH', selectedCurrency, rates) : base;
                const text = useConversion
                    ? formatCodeAfter(amount, selectedCurrency)
                    : (window.Shopify.formatMoney(c).replace('.00', '').replace(/,/g, '') + ' UAH');
                setText(productCompareAtPrice, text);
            } else {
                setText(productCompareAtPrice, '');
            }
        }

        this.updateDiscountBadge?.();
    }



    updateProductVariantPhoto() {
        if (!this.currentVariant) {
            console.warn('Variant not ready yet:', this.currentVariant);
            return;
        }

        const productSection = this.closest('.product');
        const giftCardGallery = productSection?.querySelector('[data-gift-card-gallery]');
        if (giftCardGallery) {
            const image = giftCardGallery.querySelector('[data-gift-card-image]');
            const zoomLink = giftCardGallery.querySelector('[data-gift-card-zoom]');
            const imageMapNode = giftCardGallery.querySelector('[data-gift-card-variant-images]');

            if (!image || !zoomLink || !imageMapNode) {
                console.error('Gift card gallery markup is incomplete.');
                return;
            }

            if (!giftCardGallery.variantImages) {
                try {
                    giftCardGallery.variantImages = JSON.parse(imageMapNode.textContent);
                } catch (error) {
                    console.error('Unable to parse gift card variant images.', error);
                    giftCardGallery.variantImages = {};
                }
            }

            const imageData = giftCardGallery.variantImages[String(this.currentVariant.id)];
            if (!imageData) {
                image.removeAttribute('src');
                image.removeAttribute('srcset');
                image.removeAttribute('width');
                image.removeAttribute('height');
                image.setAttribute('hidden', '');
                zoomLink.removeAttribute('href');
                zoomLink.removeAttribute('data-fancybox');
                return;
            }

            image.src = imageData.src;
            image.srcset = imageData.srcset;
            image.width = imageData.width;
            image.height = imageData.height;
            image.alt = imageData.alt;
            image.removeAttribute('hidden');
            zoomLink.href = imageData.zoomUrl;
            zoomLink.dataset.fancybox = 'gift-card-image';
            return;
        }

        // Беремо зображення з варіанту
        const variantImage = this.currentVariant.featured_image?.src || this.currentVariant.featured_media?.preview_image?.src;
        if (!variantImage) {
            console.warn('Variant image not found in currentVariant:', this.currentVariant);
            return;
        }

        // Обрізаємо домен і параметри для чистоти пошуку
        const cleanImageName = variantImage.split('/').pop().split('?')[0].toLowerCase();

        const slides = document.querySelectorAll('.productGalleria2 .swiper-slide');

        let matchingSlide = Array.from(slides).find(slide => {
          const img = slide.querySelector('img');
          if (!img) return false;
          return img.src.toLowerCase().includes(cleanImageName);
        });

        if (matchingSlide && window.productGallerySwiper) {
          const matchingIndex = Array.from(matchingSlide.parentElement.children).indexOf(matchingSlide);
          if (matchingIndex !== -1) {
            window.productGallerySwiper.slideTo(matchingIndex);
          }
        } else {
          console.warn(`No slide found for variant image: ${cleanImageName}`);
        }
    }

    updateMasterId() {
      const errorMessage = document.querySelector('.product-form__error-message-wrapper');
      this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
              return this.options[index] === option;
          }).includes(false);
      });
      this.updateProductVariantPhoto();
      this.updateProductFormId();
      this.updateProductOrderNote();
      errorMessage?.classList.add('d-none');
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    updateProductFormId() {
      const productFormValueId = document.querySelector('#variant-id');
      if (productFormValueId && this.currentVariant) {
        productFormValueId.value = this.currentVariant.id;
      }
    }

    updateProductOrderNote() {
      const orderNote = this.closest('.product')?.querySelector('product-order-note');
      orderNote?.setVariantAvailability(Boolean(this.currentVariant?.available));
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html')

                const priceSource = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const price = document.getElementById(`price-${this.dataset.section}`);
                if (price && priceSource) {
                    price.innerHTML = priceSource.innerHTML;
                  if (window.enabledCurrencySelector) {
                      updatePrices()
                    }
                }

                const btnTextSource = html.getElementById(`addBtnText-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const btnText = document.getElementById(`addBtnText-${this.dataset.section}`);
                if (btnText && btnTextSource) {
                    btnText.innerHTML = btnTextSource.innerHTML;
                }

                const noticeDeliverySource = html.getElementById(`noticeDelivery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const noticeDelivery = document.getElementById(`noticeDelivery-${this.dataset.section}`);
                if (noticeDelivery && noticeDeliverySource) {
                    noticeDelivery.innerHTML = noticeDeliverySource.innerHTML;
                }
                const productForm = document.getElementById(`product-form-${this.dataset.section}`);
                if (!productForm) return;
                const addButton = productForm.querySelector('[name="add"]');
                if (!addButton) return;

                if (this.currentVariant.available) {
                    addButton.classList.remove('disabled');
                    this.toggleAddButton(false, window.variantStrings.soldOut);

                } else {
                    addButton.classList.add('disabled');
                    this.toggleAddButton(true, window.variantStrings.soldOut);
                }
                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant
                    }
                });
            });
    }


    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
        } else {
            addButton.removeAttribute('disabled');
        }

        if (!modifyClass) return;
    }

}

customElements.define('variant-radios', Variants);



class VariantsCard extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateProductVariantPhoto() {
    if (!this.currentVariant) {
      console.warn('Variant not ready yet:', this.currentVariant);
      return;
    }

    // Беремо зображення з варіанту
    const variantImage = this.currentVariant.featured_image?.src || this.currentVariant.featured_media?.preview_image?.src;
    if (!variantImage) {
      console.warn('Variant image not found in currentVariant:', this.currentVariant);
      return;
    }

    // Обрізаємо домен і параметри для чистоти пошуку
    const cleanImageName = variantImage.split('/').pop().split('?')[0].toLowerCase();

    let closestProduct = this.closest(".product-slider-item") || this.closest(".product-card");
    if (window.innerWidth < 992) {
      const productId = this.closest(".card-popup-product-form").dataset.productId;
      closestProduct = document.querySelector(`.product--${productId}`);
    }
    const sliderLocal = closestProduct.querySelector('.swiper');
    const slides = closestProduct.querySelectorAll('.swiper .swiper-slide');
    const swiperInstance = sliderLocal?.swiper;


    let matchingSlide = Array.from(slides).find(slide => {
      const img = slide.querySelector('img');
      if (!img) return false;
      return img.src.toLowerCase().includes(cleanImageName);
    });

    if (matchingSlide && swiperInstance) {
      const matchingIndex = Array.from(matchingSlide.parentElement.children).indexOf(matchingSlide);
      if (matchingIndex !== -1) {
        swiperInstance.slideTo(matchingIndex);
      }
    } else {
      console.warn(`No slide found for variant image: ${cleanImageName}`);
    }
  }

  updateMasterId() {
    const errorMessage = this.closest('.product-card')?.querySelector('.product-form__error-message-wrapper');
      this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
              return this.options[index] === option;
          }).includes(false);
      });

    this.updateProductVariantPhoto();
    this.updateProductFormId();
    errorMessage?.classList.add('d-none');
  }

  getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
  }

  updateProductFormId() {
    const productFormValueId = this.closest('.card-popup-product-form').querySelector('.variant-id');
    if (productFormValueId && this.currentVariant) {
      productFormValueId.value = this.currentVariant.id;
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      if (disable) {
          addButton.setAttribute('disabled', 'disabled');
      } else {
          addButton.removeAttribute('disabled');
      }

      if (!modifyClass) return;
  }

}
customElements.define('variant-radios-card', VariantsCard);

class VariantsCart extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false;
    this.inputOpener();
    this.addEventListener('change', this.onVariantChange);
  }

  async onVariantChange() {
    if (this.isUpdating) return;

    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) return;

    await this.updateCartItem();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    this.updateProductFormId();
  }

  getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
  }

  updateProductFormId() {
    const productFormValueId = this.closest('.cart-popup-product-data-wrap').querySelector('.variant-id');
    if (productFormValueId && this.currentVariant) {
      productFormValueId.value = this.currentVariant.id;
    }
  }

  async updateCartItem() {
    const productFormValueId = this.closest('.cart-popup-product-data-wrap').querySelector('.variant-id');
    const value = productFormValueId.value;
    const quantity = this.closest('.cart-popup-product-data-wrap').querySelector('.quantity input').value;
    const cartProductForm = this.closest('.cart-popup-product-data-wrap').querySelector('.cart-product-form');
    const oldItemKey = cartProductForm.dataset.key;
    const propertiesNode = cartProductForm.querySelector('[data-cart-item-properties]');
    const cartPopup = document.querySelector('#cart-popup');
    const radioInputs = Array.from(this.querySelectorAll('input[type="radio"]'));
    const disabledStates = radioInputs.map((input) => input.disabled);
    let properties = {};

    try {
      const parsedProperties = propertiesNode ? JSON.parse(propertiesNode.textContent) : {};
      properties = this.normalizeCartProperties(parsedProperties);
    } catch (error) {
      console.error('Unable to parse cart item properties.', error);
    }

    cartProductForm
      .querySelectorAll('.product-form-inputs--properties input[name^="properties["]:checked')
      .forEach((input) => {
        const propertyName = input.name.match(/\[([^\]]+)\]/)?.[1];
        if (propertyName) properties[propertyName] = input.value;
      });

    this.isUpdating = true;
    radioInputs.forEach((input) => {
      input.disabled = true;
    });
    cartPopup?.classList.add('loading');

    try {
      const cartRoot = window.Shopify?.routes?.root || '/';

      await this.requestCartChange(`${cartRoot}cart/add.js`, {
        items: [{
          id: Number(value),
          quantity: Number(quantity),
          properties
        }]
      });

      await this.requestCartChange(`${cartRoot}cart/change.js`, {
        id: oldItemKey,
        quantity: 0
      });

      const rendered = await renderCart();
      if (!rendered) throw new Error('Unable to refresh cart drawer.');
      updateCartItemsCount();
    } catch (error) {
      console.error('Unable to change cart item variant.', error);

      const rendered = await renderCart();
      if (rendered) updateCartItemsCount();
      const errorItem = rendered
        ? Array.from(document.querySelectorAll('#cart-popup .cart-popup-product'))
          .find((item) => item.dataset.key === oldItemKey)
        : cartProductForm.closest('.cart-popup-product');

      errorItem?.querySelector('.cart-variant-update-error')?.classList.remove('d-none');
    } finally {
      this.isUpdating = false;
      radioInputs.forEach((input, index) => {
        input.disabled = disabledStates[index];
      });
      document.querySelector('#cart-popup')?.classList.remove('loading');
    }
  }

  normalizeCartProperties(properties) {
    const propertyEntries = Array.isArray(properties)
      ? properties
      : properties && typeof properties === 'object'
        ? Object.entries(properties)
        : [];

    return Object.fromEntries(
      propertyEntries.map(([name, value]) => [
        this.decodeCartProperty(name),
        this.decodeCartProperty(value)
      ])
    );
  }

  decodeCartProperty(value) {
    if (typeof value !== 'string') return value;

    const textarea = document.createElement('textarea');
    textarea.innerHTML = value
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    return textarea.value;
  }

  async requestCartChange(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();

    if (!response.ok || data.status >= 400) {
      throw new Error(data.description || data.message || 'Cart request failed.');
    }

    return data;
  }
  inputOpener() {
    const fieldsets = this.querySelectorAll("fieldset");
    fieldsets.forEach(fieldset => {
      const firstRadioButtonLabel = fieldset.querySelector("[type='radio']:checked+label");
      const label = fieldset.querySelector(".card__input-selected-label");

      // change activ lable after select option
      label.innerHTML = firstRadioButtonLabel?.innerHTML;
      const radioButtonLabels = fieldset?.querySelectorAll("label");
      radioButtonLabels.forEach(radioLabel => {
        radioLabel.addEventListener("click", ()=>{
          label.innerHTML = radioLabel.innerHTML;
        })
      });

      // open popup options
      const inputWrap = fieldset.querySelector('.card__inputs-wrap');
      const inputItems = fieldset.querySelectorAll('.card__input-wrap');

      function closeAll() {
        fieldsets.forEach(otherFieldset => {
          const otherInputWrap = otherFieldset.querySelector('.card__inputs-wrap');
          // const otherFieldsetClass = otherFieldset.querySelector('fieldset');

          if (otherInputWrap && otherInputWrap !== inputWrap) {
            otherInputWrap.style.height = '0';
            otherFieldset.classList.remove("open");
            otherInputWrap.style.overflow = "hidden";
            setTimeout(() => {
              otherInputWrap.style.overflow = "auto";
            }, 300);
          }
        });
      }

      function toggleInputWrap() {
        closeAll();
        if (inputWrap.style.height === '120px') {
          close();
        } else {
          open();
        }
      }
      label.addEventListener('click', toggleInputWrap);
      inputItems.forEach(item => {
        item.addEventListener('click', close);
      });
      function open() {
        document.querySelector(".product-form-inputs.open")?.classList.remove("open");
        inputWrap.style.height = '120px';
        fieldset.classList.add("open");
        inputWrap.style.overflow = "hidden";
        setTimeout(() => {
          inputWrap.style.overflow = "auto";
        }, 300);
      }
      function close() {
        inputWrap.style.height = '0';
        fieldset.classList.remove("open");
        inputWrap.style.overflow = "hidden";
        setTimeout(() => {
          inputWrap.style.overflow = "auto";
        }, 300);
      }
    });
  }
}
customElements.define('variant-radios-cart', VariantsCart);


// Infinite scroll for product grid
function initInfiniteScroll(section) {
    if (!section) return;

    const arrows   = section.querySelector('.scroll-arrows');
    const btnUp    = arrows.querySelector('.scroll-up');
    const btnDown  = arrows.querySelector('.scroll-down');
    const grid     = section.querySelector('.prod-grid-box');
    const sentinel = section.querySelector('.infinite-sentinel');

    const initialPage = Number(grid.dataset.currentPage) || 1;
    let currentPage   = initialPage;
    const totalPages  = Number(grid.dataset.totalPages) || 1;

    const PREFETCH_PAGES   = 2;
    const UNLOCK_DELTA_PX  = 60;

    let loading           = false;
    let firstLoadDone     = false;
    let suppressAutoLoad  = false;
    let downClickBaseY    = 0;
    let lastScrollY       = window.scrollY;
    let observerActive    = false;

    grid.querySelectorAll('.product-card').forEach(card => card.classList.add('visible'));

    const buildPageURL = (page) => {
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        return url.pathname + (url.search || '');
    };

    const isSectionInViewport = () => {
        const r = section.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight;
    };

    const updateArrowsFixed = () => {
        const r = section.getBoundingClientRect();
        if (!isSectionInViewport()){
            arrows.classList.remove('show', 'fixed');
            return;
        }
        if (firstLoadDone) arrows.classList.add('show'); else arrows.classList.remove('show');
        if (r.top < 0 || r.bottom > window.innerHeight) arrows.classList.add('fixed');
        else arrows.classList.remove('fixed');
    };

    const showArrowsAfterLoad = () => {
        firstLoadDone = true;
        updateArrowsFixed();
    };

    const loadPages = async (startPage, count) => {
        if (loading) return;
        loading = true;
        grid.classList.add('loading');

        try {
            for (let p = startPage; p < startPage + count && p <= totalPages; p++) {
                if (suppressAutoLoad) {
                    console.log('[Infinite] Автолоад заблоковано. Зупиняюсь на сторінці', p);
                    break;
                }

                const url  = buildPageURL(p);
                const res  = await fetch(url, { credentials: 'same-origin' });
                const html = await res.text();
                const doc     = new DOMParser().parseFromString(html, 'text/html');
                const nextBox = doc.querySelector('[data-infinite-scroll-products] .prod-grid-box');

                if (!nextBox) {
                    console.warn('[Infinite] Не знайдено .prod-grid-box на сторінці', p);
                    break;
                }

                const items = Array.from(nextBox.children);
                console.log('[Infinite] сторінка', p, 'елементів:', items.length);

                const frag = document.createDocumentFragment();
                items.forEach(node => {
                    node.classList.add('visible');
                    frag.appendChild(node);
                });
                grid.appendChild(frag);

                currentPage = p;
                grid.dataset.currentPage = String(currentPage);
                showArrowsAfterLoad();

                setTimeout(() => {
                  // console.log("sliderOnProductCard - [Infinite] сторінка");
                  sliderOnProductCard();
                }, 300);
            }

            if (currentPage >= totalPages && sentinel && observerActive) {
                observer.disconnect();
                observerActive = false;
            }
        } catch (e) {
            console.error('[Infinite] Помилка завантаження:', e);
        } finally {
            grid.classList.remove('loading');
            loading = false;
            updateArrowsFixed();
        }
    };

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            if (!isSectionInViewport()) continue;

            const pagesLeft = totalPages - currentPage;
            if (pagesLeft <= 0) return;
            if (suppressAutoLoad) {
                console.log('[Infinite] Сентинел у полі зору, але автолоад заблоковано.');
                return;
            }

            const count = Math.min(pagesLeft <= 2 ? pagesLeft : PREFETCH_PAGES, pagesLeft);
            console.log('[Infinite] Sentinel: вантажу', count, 'стор.');
            loadPages(currentPage + 1, count);
        }
    }, { root: null, rootMargin: '600px 0px 1000px 0px', threshold: 0 });

    if (sentinel) { observer.observe(sentinel); observerActive = true; }

    if (currentPage < totalPages) {
        const preload = Math.min(PREFETCH_PAGES, totalPages - currentPage);
        loadPages(currentPage + 1, preload);
    }

    btnUp.addEventListener('click', () => {
        suppressAutoLoad = false;
        const headerOffset = window.innerWidth < 768 ? 120 : 170;
        const sectionTop = section.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: sectionTop, behavior: 'smooth' });
    });

    btnDown.addEventListener('click', () => {
        suppressAutoLoad = true;
        downClickBaseY = window.scrollY;
        const last = grid.lastElementChild;
        if (last) {
            last.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    });

    window.addEventListener('scroll', () => {
        const dirUp = window.scrollY < lastScrollY;
        if (dirUp && suppressAutoLoad && (downClickBaseY - window.scrollY) >= UNLOCK_DELTA_PX) {
            suppressAutoLoad = false;
            console.log('[Infinite] Рух вгору на', (downClickBaseY - window.scrollY), 'px → знято блок автолоаду');
        }
        lastScrollY = window.scrollY;
        updateArrowsFixed();
    }, { passive: true });

    updateArrowsFixed();
}

// Ініціалізація при першому завантаженні сторінки
document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-infinite-scroll-products]');
    initInfiniteScroll(section);
});

// Перезапуск логіки після AJAX/фільтрів
document.addEventListener('infiniteScroll:reload', () => {
    console.log('[Infinite] Перезапуск після події infiniteScroll:reload');
    const section = document.querySelector('[data-infinite-scroll-products]');
    initInfiniteScroll(section);
    setTimeout(() => {
      sliderOnProductCard();
    }, 300);
});

// Автоматичне виявлення нової секції через MutationObserver
const observerReload = new MutationObserver((mutations) => {
    for (const m of mutations) {
        for (const node of m.addedNodes) {
            if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-infinite-scroll-products')) {
                console.log('[Infinite] Виявлено оновлену секцію, ініціалізую знову');
                initInfiniteScroll(node);
                setTimeout(() => {
                  sliderOnProductCard();
                }, 300);
            }
        }
    }
});
observerReload.observe(document.body, { childList: true, subtree: true });
/*
==============================
Як вручну тригерити подію для перезапуску infinite scroll після AJAX:
==============================
document.dispatchEvent(new Event('infiniteScroll:reload'));
*/
// Infinite scroll for product grid
function changePrintStyle(){
    window.print();
}


class popupProductCard extends HTMLElement {
  constructor() {
    super();
     this.loadPopup();
  }

  loadPopup() {
    const popup = this;
    const triggerButton = this.querySelector(".card-popup-trigger");
    const productForm = this.querySelector(".card-popup-product-form");
    const productFormCloseButton = this.querySelector(".card-popup-product-form-close");
    const addToCartButton = this.querySelector(".js-product-buy-button");

    // window.addEventListener('scroll', ()=>{
    //   popup.classList.remove("open");
    // });

    // open card popup
    triggerButton.addEventListener("click", ()=>{
      document.querySelector(".card-popup-product-form.open")?.classList.remove("open");
      productForm.classList.add("open");
      productFormCloseButton.addEventListener("click", closePopup)
      addToCartButton.addEventListener("click", closePopup)
      function closePopup() {
        if (window.innerWidth <= 991) {
          popup.appendChild(productForm);
          productForm.classList.remove("open");
        } else {
          productForm.classList.remove("open");
        }
      }
      if (window.innerWidth <= 991) {
        document.body.appendChild(productForm);
      }
    })

    const fieldsets = this.querySelectorAll("fieldset");

    fieldsets.forEach(fieldset => {
      const firstRadioButtonLabel = fieldset.querySelector("[type='radio']+label");
      const label = fieldset.querySelector(".card__input-selected-label");

      label.innerHTML = firstRadioButtonLabel?.innerHTML;
      const radioButtonLabels = fieldset?.querySelectorAll("label");
      radioButtonLabels.forEach(radioLabel => {
        radioLabel.addEventListener("click", () => {
          label.innerHTML = radioLabel.innerHTML;
        });
      });

      const inputWrap = fieldset.querySelector('.card__inputs-wrap');
      const inputItems = fieldset.querySelectorAll('.card__input-wrap');

      function closeAll() {
        fieldsets.forEach(otherFieldset => {
          const otherInputWrap = otherFieldset.querySelector('.card__inputs-wrap');
          // const otherFieldsetClass = otherFieldset.querySelector('fieldset');

          if (otherInputWrap && otherInputWrap !== inputWrap) {
            otherInputWrap.style.height = '0';
            otherFieldset.classList.remove("open");
            otherInputWrap.style.overflow = "hidden";
            setTimeout(() => {
              otherInputWrap.style.overflow = "auto";
            }, 300);
          }
        });
      }

      function toggleInputWrap() {
        closeAll();
        if (inputWrap.style.height === '120px') {
          close();
        } else {
          open();
        }
      }

      label.addEventListener('click', toggleInputWrap);
      inputItems.forEach(item => {
        item.addEventListener('click', close);
      });
      function open() {
        inputWrap.style.height = '120px';
        fieldset.classList.add("open");
        inputWrap.style.overflow = "hidden";
        setTimeout(() => {
          inputWrap.style.overflow = "auto";
        }, 300);
      }
      function close() {
        inputWrap.style.height = '0';
        fieldset.classList.remove("open");
        inputWrap.style.overflow = "hidden";
        setTimeout(() => {
          inputWrap.style.overflow = "auto";
        }, 300);
      }
    });

  }
}
customElements.define('card-popup', popupProductCard);



// nova post Cookie
document.addEventListener('DOMContentLoaded', function () {
  const containerNP = document.querySelector('.address-nova-post__container');
  if (!containerNP) return;

  function setCookie(name, value, days = 365) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  function getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '');
  }

  // Elements to track
  const radioInputs = document.querySelectorAll('.radio-wrap.form__input-wrapper input[type="radio"][name="variant"]');
  const fields = [
    'city-search',
    'warehouse-search',
    'address-street',
    'address-build',
    'address-flat'
  ];

  // Restore previous values from cookies
  const savedRadio = getCookie('selectedRadio');
  if (savedRadio) {
    const radio = document.querySelector(`input[type="radio"][name="variant"][value="${savedRadio}"]`);
    if (radio) {
      setTimeout(() => {
        radio.click();
      }, 10);
    }
  }

  fields.forEach(id => {
    const saved = getCookie(id);
    const input = document.getElementById(id);
    if (input && saved) {
      input.value = saved;
    }
  });

  // Save radio change
  radioInputs.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        setCookie('selectedRadio', this.value);
      }
    });
  });

  // Save input changes
  fields.forEach(id => {
    const input = document.getElementById(id);
    if (input) {
      let lastValue = input.value;
      // program chenged value, addEventListener input and change dos`nt work.
      setInterval(() => {
        if (input.value !== lastValue) {
          lastValue = input.value;
          setCookie(id, input.value);
        }
      }, 500);
    }
  });
});
